import React, { useRef, useState, useEffect } from 'react'
import { Card } from 'react-bootstrap'

import ToggleGroupIcon from '../../AnimatedIcons/ToggleGroupIcon/ToggleGroupIcon'

import './ContentBlock.scss'

interface Props {
  title: string
  children?: React.ReactNode
  collapsable?: boolean
  collapseKey?: string
  isCollapsed?: boolean
}

const ContentBlock = ({ title, children, collapsable, collapseKey, isCollapsed = false }: Props) => {
  const [isOpen, setIsOpen] = useState(!isCollapsed)
  const [height, setHeight] = useState<string | number>(!isCollapsed ? 'auto' : 0)
  const contentRef = useRef<HTMLDivElement>(null)

  const toggleCollapse = () => {
    if (!collapsable) return

    const contentEl = contentRef.current
    if (!contentEl) return

    if (isOpen) {
      // Close: from scrollHeight to 0
      setHeight(contentEl.scrollHeight)
      requestAnimationFrame(() => {
        setHeight(0)
      })

      if (collapseKey)
        localStorage.setItem(collapseKey, 'true')
    } else {
      // Open: from 0 to scrollHeight, then auto
      setHeight(contentEl.scrollHeight)

      if (collapseKey)
        localStorage.setItem(collapseKey, 'false')
    }

    setIsOpen(prev => !prev)
  }

  // When open, set to auto after animation ends
  useEffect(() => {
    if (isOpen && height !== 'auto') {
      const timeout = setTimeout(() => {
        setHeight('auto')
      }, 400) // must match CSS transition duration

      return () => clearTimeout(timeout)
    }
  }, [isOpen, height])

  return (
    <Card className='content-block'>
      <Card.Header
        className={`${collapsable ? 'cursor-pointer' : ''}`}
        onClick={toggleCollapse}
      >
        <Card.Title as={'h3'}>{title}</Card.Title>
        {collapsable && (
          <div style={{ marginTop: '-5px' }}>
            <ToggleGroupIcon isOpen={isOpen} size={18} />
          </div>
        )}
      </Card.Header>

      <div
        ref={contentRef}
        className='content-block__body-wrapper'
        style={{
          height: collapsable ? height : 'auto',
        }}
      >
        <Card.Body>{children}</Card.Body>
      </div>
    </Card>
  )
}

export default ContentBlock